import { useCallback, useEffect, useReducer } from 'react';
import { useMount } from 'react-use';

import useActions from '../../hooks/useActions';
import { getProductReviewDetailActions } from '../../redux/actions/getProductReviewDetailActions';
import { getProductReviewListDataActions } from '../../redux/actions/getProductReviewListDataActions';
import { ListLoadingTypes } from '../../types/Common';
import * as navigationService from '../../utils/navigationService';
import * as routeUtils from '../../utils/routes/utils';
import reducer, { defaultState } from './reducer';

export const useData = (id: string) => {
  const [data, dispatch] = useReducer(reducer, defaultState);

  const [getHeaderData, getListData] = useActions([
    getProductReviewDetailActions.request,
    getProductReviewListDataActions.request,
  ]);

  const fetchData = useCallback(
    (type: ListLoadingTypes, page: number) => {
      if (type === 'new' || type === 'reload') {
        getHeaderData({ loadingType: type, id, dispatch });
      }

      getListData({
        loadingType: type,
        id,
        page,
        dispatch,
      });
    },
    [getHeaderData, getListData, id, dispatch]
  );

  useMount(() => {
    fetchData('new', 1);
  });

  useEffect(() => {
    if (data.isDetailError) {
      const shouldWebReplace = true;

      navigationService.replace(
        'NotFoundPage',
        {
          from: encodeURIComponent(
            routeUtils.compileToPath('ItemReviewsPage', { id })
          ),
        },
        shouldWebReplace
      );
    }
  }, [data.isDetailError]);

  return {
    fetchData,
    data,
  };
};
